import { motion } from 'framer-motion';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-trophy-line',
      title: '大願成就',
      description: 'こつこつと努力を重ねて大きな願いを成就させる',
      image: 'https://public.readdy.ai/ai/img_res/8c331fa1ca1d4e7835f06532538ef0a8.jpg'
    },
    {
      icon: 'ri-sword-line',
      title: '必勝祈願',
      description: '仇討ちを成功し勝利した',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20ukiyo-e%20woodblock%20print%20showing%20group%20of%20forty%20seven%20ronin%20samurai%20warriors%20raising%20victory%20cry%20after%20successful%20night%20raid%20stern%20serious%20expressions%20without%20smiles%20showing%20gravity%20of%20their%20mission%20many%20warriors%20celebrating%20together%20with%20intense%20determined%20faces%20snow%20falling%20traditional%20art%20style%20depicting%20triumphant%20moment%20with%20solemn%20atmosphere%20dramatic%20composition%20simple%20background&width=500&height=600&seq=hissho003&orientation=portrait'
    },
    {
      icon: 'ri-focus-3-line',
      title: 'オールイン',
      description: '勝機を見出し、そこへ全てをかけて勝利する',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20traditional%20art%20close-up%20portrait%20of%20samurai%20warrior%20face%20showing%20deep%20contemplation%20and%20powerful%20determination%20eyes%20filled%20with%20strong%20resolve%20and%20decisive%20spirit%20intense%20focused%20expression%20representing%20moment%20of%20critical%20decision%20making%20powerful%20facial%20features%20conveying%20unwavering%20commitment%20ukiyo-e%20style%20with%20dramatic%20lighting%20emphasizing%20strength%20of%20character%20simple%20refined%20background&width=500&height=600&seq=allin003&orientation=portrait'
    }
  ];

  return (
    <section className="bg-[#0A0A0A] py-24 px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block px-4 py-1 bg-[#D4AF37]/20 border border-[#D4AF37] rounded-full mb-6">
            <span className="text-[#D4AF37] text-sm tracking-wider">御利益</span>
          </div>
          <h2 className="text-white font-serif text-5xl font-bold tracking-wide">大石神社の御利益</h2>
          <p className="text-gray-400 mt-6 text-lg">忠義と勇気の精神が導く三つの御利益</p>
        </motion.div>

        <div className="grid grid-cols-3 gap-10">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group cursor-pointer"
            >
              <div className="bg-white/5 border border-[#D4AF37]/30 rounded-lg overflow-hidden hover:border-[#D4AF37] transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.3)]">
                <div className="h-72 overflow-hidden">
                  <img 
                    src={benefit.image} 
                    alt={benefit.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="p-8 text-center">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#D4AF37]/10 rounded-full">
                    <i className={`${benefit.icon} text-[#D4AF37] text-3xl`}></i>
                  </div>
                  <h3 className="text-white font-bold text-2xl mb-4 tracking-wide">{benefit.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{benefit.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
